import { FormNode, MessageModel, readMessageModelByCode, Severity } from '@msdk/definitions'

function isError(type: Severity): boolean {
  return type === Severity.Error || type === Severity.Mandatory
}

export function isMessageVisible(message: MessageModel, node?: FormNode): boolean {
  return !isError(message.type) || node?.value.validationRevealed !== false
}

export function hasErrorMessage(node: FormNode): boolean {
  return node.value.validationMessages.some((code) => {
    const message = readMessageModelByCode(code)
    return message !== undefined && isError(message.type)
  })
}
